export const environment = {
  production: true,
  MBTA_API_URL: 'https://api-v3.mbta.com',
  MBTA_API_KEY: 'd7dc86f71fc8433db7c731fd00cec892',
  OPEN_WEATHER_API_URL: 'https://api.openweathermap.org/data/2.5/weather',
  OPEN_WEATHER_API_KEY: 'a221b058c527d762480571ef7de87997',
  ENABLE_ANALYTICS: true,
  GA_MEASUREMENT_ID: 'UA-148723860-1',
  Allowed_Users: 'greg.szilagyi@malegislature.gov,yu.zhang@malegislature.gov,daniel.neville@malegislature.gov,jason.keohane@mass.gov'
};
